// extracted by mini-css-extract-plugin
export default {"DevDashboard":"DevDashboard_DevDashboard__MZWoK","TableContainer":"DevDashboard_TableContainer__-Ff4t"};